"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoChat/VideoSettingsModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _log = require('shared/log');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');

















/* SAFETY: kept from the JS version: option values are numeric indexes, not strings.
 * SimpleSelect hides an option whose value is falsy, so the first device (0)
 * stays hidden in the list. A string '0' would show it, which is a behaviour
 * change, so the number is passed through SimpleSelect's string type. */
const indexValue = (i) => i 

const VideoSettingsModal = ({
  open,
  onClose,
  cameras,
  currentCamera,
  mics,
  currentMic,
  onChangeVideo,
  onChangeAudio,
}) => {
  const changeVideo = _react.useCallback.call(void 0, (value) => {
    const v = parseInt(value)
    if (v === currentCamera) {
      _log.log.info("Camera did not change")
      return
    }

    _log.log.info("Changing Video From Modal: " + currentCamera + " to " + v)
    onChangeVideo(v)
    onClose()
  }, [currentCamera, onChangeVideo, onClose])

  const changeAudio = _react.useCallback.call(void 0, (value) => {
    const v = parseInt(value)
    if (v === currentMic) {
      _log.log.info("Mic did not change")
      return
    }

    _log.log.info("Changing Audio From Modal: " + currentMic + " to " + v)
    onChangeAudio(v)
    onClose()
  }, [currentMic, onChangeAudio, onClose])

  const micOptions = mics.map((m, i) => {
    return { label: m.name || ("Microphone " + i), value: indexValue(i) }
  })
  const videoOptions = cameras.map((c, i) => {
    return { label: c.name || ("Camera " + i), value: indexValue(i) }
  })
  return (
    _react2.default.createElement(_Modal2.default, {
      className: "video-chat--settings-modal",
      isOpen: open,
      onClose: onClose,
      title: "Video Settings" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}

      , _react2.default.createElement('div', { className: "video-chat--settings-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
        , _react2.default.createElement('div', { className: "video-chat--settings-section-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
          , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}, "videocam")
        )
        ,  videoOptions.length > 0
          ? (
              _react2.default.createElement(_Form.InputSectionWrapper, { title: "Video Source" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
                , _react2.default.createElement(_Form.SimpleSelect, {
                  options: videoOptions,
                  value: currentCamera.toString(),
                  onChange: changeVideo, __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
                )
              )
            )
          : null
        
      )
      , _react2.default.createElement('div', { className: "video-chat--settings-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}
        , _react2.default.createElement('div', { className: "video-chat--settings-section-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 94}}
          , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}, "mic")
        )
        ,  micOptions.length > 0
          ? (
            _react2.default.createElement(_Form.InputSectionWrapper, { title: "Audio Source" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 99}}
              , _react2.default.createElement(_Form.SimpleSelect, {
                options: micOptions,
                value: currentMic.toString(),
                onChange: changeAudio, __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}
              )
            )
            )
          : null
        
      )
    )
  )
}

exports. default = VideoSettingsModal
